const HomeActionTypes = {
    HOME_SYNC_START: 'HOME_SYNC_START',
    HOME_SYNC_FINISH: 'HOME_SYNC_FINISH',
    
    // SAGA
    VALIDATE_CODE:'VALIDATE_CODE',
};

export default HomeActionTypes;